'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _relayQueries = require('./relayQueries');

var _relayQueries2 = _interopRequireDefault(_relayQueries);

var _relayMutation = require('./relayMutation');

var _relayMutation2 = _interopRequireDefault(_relayMutation);

var _fetchWithMiddleware = require('./fetchWithMiddleware');

var _fetchWithMiddleware2 = _interopRequireDefault(_fetchWithMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RelayNetworkLayer = function () {
  function RelayNetworkLayer(middlewares, options) {
    var _this = this;

    _classCallCheck(this, RelayNetworkLayer);

    this._options = options;
    this._middlewares = Array.isArray(middlewares) ? middlewares : [middlewares];
    this._supportedOptions = [];

    this._middlewares.forEach(function (mw) {
      if (mw && mw.supports) {
        if (Array.isArray(mw.supports)) {
          var _supportedOptions;

          (_supportedOptions = _this._supportedOptions).push.apply(_supportedOptions, _toConsumableArray(mw.supports));
        } else {
          _this._supportedOptions.push(mw.supports);
        }
      }
    });

    this.supports = this.supports.bind(this);
    this.sendQueries = this.sendQueries.bind(this);
    this.sendMutation = this.sendMutation.bind(this);
  }

  _createClass(RelayNetworkLayer, [{
    key: 'supports',
    value: function supports() {
      var _this2 = this;

      for (var _len = arguments.length, options = Array(_len), _key = 0; _key < _len; _key++) {
        options[_key] = arguments[_key];
      }

      return options.every(function (option) {
        return _this2._supportedOptions.indexOf(option) !== -1;
      });
    }
  }, {
    key: 'sendQueries',
    value: function sendQueries(requests) {
      var _this3 = this;

      return (0, _relayQueries2.default)(requests, function (req) {
        return (0, _fetchWithMiddleware2.default)(req, _this3._middlewares);
      });
    }
  }, {
    key: 'sendMutation',
    value: function sendMutation(request) {
      var _this4 = this;

      return (0, _relayMutation2.default)(request, function (req) {
        return (0, _fetchWithMiddleware2.default)(req, _this4._middlewares);
      });
    }
  }]);

  return RelayNetworkLayer;
}();

exports.default = RelayNetworkLayer;


//////////////////
// WEBPACK FOOTER
// ./~/react-relay-network-layer/lib/relayNetworkLayer.js
// module id = 1518
// module chunks = 0